import * as React from "react";
import { ICouncil } from "src/interfaces";
import axios from "axios";
import * as qs from "query-string-for-all";
import { baseUrl } from "src/constants/ApiSettings";

interface IProps {
  council: ICouncil;
  year: string;
  where: string;
}

interface IState {
  whereDataSays?: string;
}

export default class CouncilSaysContent extends React.PureComponent<
IProps, 
IState, 
{}> {

  public state: IState = {};

  public componentDidMount() {
    this.generateCouncilSays(this.props.council, this.props.where, this.props.year);
  }

  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.year !== this.props.year) {
      this.generateCouncilSays(newProps.council, newProps.where, newProps.year);
    }
  }

  public generateCouncilSays = (council: ICouncil, where: string, year: string) => {
    axios
      .all([
        axios.get(
          `${baseUrl}/${ where }?${qs.stringify({
            council: council.id,
            year
          })}`
        )
      ])
      .then(
        axios.spread(( 
          whereData, 
        ) => {

          // Need to transform this data into the right shape
          const whereDataSays = whereData.data[0].value;

          return { 
            whereDataSays
          };
        })
      )
      .then(generatedData => {
        this.setState(generatedData);
      });
  };

  public render() {
    return (
      <div className="council-says-content">
        { ( this.state.whereDataSays ) ? (
          <div dangerouslySetInnerHTML={{__html: this.state.whereDataSays }} />
        ) : (
          <span>No comment available</span>
        ) }
      </div>
    );

  }
}


// WEBPACK FOOTER //
// ./src/components/general/CouncilSaysContent.tsx